'use client';

import * as React from 'react';

import { DiscoverDayStrip, type DiscoverDayStripProps } from './DiscoverDayStrip';
import { useDayStripSpy } from './useDayStripSpy';

export type DiscoverDayStripLiveProps = Omit<DiscoverDayStripProps, 'activeDate' | 'onChipSelect'>;

/**
 * WEB-1080 — the day strip wired as the live date anchor: the scroll-spy owns
 * `aria-current="date"`, chips jump to their day (or to the list tail), and
 * the active chip stays centred in an overflowing strip. See
 * {@link useDayStripSpy}. The spy runs only while a chip is loaded — the
 * results state; loading / empty / offline lists have no day sections.
 */
export function DiscoverDayStripLive(props: DiscoverDayStripLiveProps): React.ReactElement {
  const stripRef = React.useRef<HTMLElement>(null);
  const enabled = props.chips.some((chip) => chip.state === 'loaded' || chip.state === 'on-now');
  const { activeDate, selectChip } = useDayStripSpy(stripRef, props.chips, enabled);
  return (
    <DiscoverDayStrip {...props} ref={stripRef} activeDate={activeDate} onChipSelect={selectChip} />
  );
}
